<div class="fav-menu">
    <!-- Heart icon (next to the profile icon) -->
    <button type="button" class="fav-menu__trigger" [class.is-open]="isOpen" (click)="toggle($event)"
        title="Favorite Menu" i18n-title aria-label="Favorite Menu" i18n-aria-label
        aria-haspopup="menu" [attr.aria-expanded]="isOpen">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            aria-hidden="true">
            <path
                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
        </svg>
    </button>

    <!-- Popup -->
    <div class="fav-menu__popup" *ngIf="isOpen" role="menu">
        <div class="fav-menu__title" i18n>Favorite Menu</div>

        <div class="fav-menu__state" *ngIf="isLoading" i18n>Loading…</div>

        <div class="fav-menu__state" *ngIf="!isLoading && loadFailed" i18n>
            Unable to load your Favorite Menu. Please try again.
        </div>

        <div class="fav-menu__state" *ngIf="!isLoading && !loadFailed && !favorites.length" i18n>
            No favorite menu items have been selected.
        </div>

        <ng-container *ngIf="!isLoading && !loadFailed">
            <button type="button" class="fav-menu__item" role="menuitem"
                *ngFor="let item of favorites; trackBy: trackByMenuId" (click)="go(item)">
                <i class="fav-menu__icon" [ngClass]="iconFor(item)" aria-hidden="true"></i>
                <span>{{ item.MenuName }}</span>
            </button>
        </ng-container>
    </div>
</div>